export default __webpack_public_path__ + "static/media/72_mobile.21ac2936.jpg";